export {SuccessNotification,ErrorNotification} from './Notification'

export const getFileNameFromUrl = (url) => {
  if (!url) return ''
  const parts = url.split('/')
  const filename = parts[parts.length - 1]
  return decodeURIComponent(filename)
}

export const truncateString = (str, maxLength) => {
  if (str.length <= maxLength) return str
  return str.slice(0, maxLength) + '...'
}